import { useState, type FormEvent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../lib/auth';

export function LoginScreen() {
  const { session, operator, refreshOperator } = useAuth();
  const loc = useLocation();
  const from = (loc.state as { from?: { pathname?: string } } | null)?.from?.pathname ?? '/calendar';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (session && operator) {
    return <Navigate to={from} replace />;
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { data: signInData, error: signInErr } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });
    if (signInErr) {
      setBusy(false);
      setError(signInErr.message);
      return;
    }
    await refreshOperator(signInData.user?.id ?? null);
    setBusy(false);
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>Neoseum admin</h1>
        <p className="muted">Aanmelden met je medewerker-account.</p>

        <form onSubmit={submit} className="login-form">
          <label>
            <span>E-mail</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            <span>Wachtwoord</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error ? <div className="login-error">{error}</div> : null}
          <button type="submit" className="btn-primary" disabled={busy}>
            {busy ? 'Bezig…' : 'Aanmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
